import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, Menu, X } from 'lucide-react';
import './css/Navbar.css';
import logoImage from './images/logo.webp';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const resolveImageUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/uploads/')) return `${API_BASE_URL}${src}`;
  return src;
};

const defaultLinks = [
  { label: 'الرئيسية', path: '/' },
  { label: 'من نحن', path: '/about' },
  { label: 'خدماتنا', path: '/services' },
  { label: 'أعمالنا', path: '/our-work' },
  { label: 'المدونة', path: '/blogs' },
  { label: 'تواصل معنا', path: '/contact' },
];

const Navbar = () => {
  const [phoneNumber, setPhoneNumber] = useState('+966573394229');
  const [logoUrl, setLogoUrl] = useState('');
  const [links, setLinks] = useState(defaultLinks);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchNavbar = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/navbar`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.settings) {
          if (data.settings.phoneNumber) {
            setPhoneNumber(data.settings.phoneNumber);
          }
          if (data.settings.logoUrl) {
            setLogoUrl(data.settings.logoUrl);
          }
        }
        if (Array.isArray(data.links) && data.links.length > 0) {
          setLinks(
            data.links.map((l) => ({
              label: l.label,
              path: l.path,
            }))
          );
        }
      } catch {
        // silently fall back to defaults if API fails
      }
    };

    fetchNavbar();
  }, []);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const resolvedLogo =
    logoUrl && typeof logoUrl === 'string' ? resolveImageUrl(logoUrl) : null;

  return (
    <nav>
      <div className="container">
        <div className="navbar-content">
          {/* 1. Contact Button (Visible on Desktop) */}
          <div className="contact-btn desktop-only">
            <Link to={`https://wa.me/${phoneNumber}`}>
              <ArrowUpRightIcon className="icon" />
              تواصل معنا
            </Link>
          </div>

          {/* 2. Mobile Menu Toggle (Visible on Mobile) */}
          <div className="mobile-toggle" onClick={toggleMenu}>
            <Menu size={30} color="#000" />
          </div>

          {/* 3. Navigation Links (The Sidebar) */}
          <div className={`nav-elements ${isOpen ? 'active' : ''}`}>
            {/* Close Button for Mobile Sidebar */}
            <div className="mobile-header">
              <div className="close-btn" onClick={toggleMenu}>
                <X size={30} color="#000" />
              </div>
            </div>

            {links.map((link) => (
              <div key={`${link.path}-${link.label}`} className="nav-element">
                <Link to={link.path} onClick={toggleMenu}>
                  {link.label}
                </Link>
              </div>
            ))}

            {/* Mobile Contact Button inside menu */}
            <div className="contact-btn mobile-only">
              <Link to={`https://wa.me/${phoneNumber}`}>
                <ArrowUpRightIcon className="icon" />
                تواصل معنا
              </Link>
            </div>
          </div>

          {/* 4. Overlay Background */}
          {isOpen && <div className="nav-overlay" onClick={toggleMenu} />}

          {/* 5. Logo */}
          <div className="logo">
            <Link to="/">
              {resolvedLogo ? (
                <img src={resolvedLogo} alt="نبض كير - Nabd Care" />
              ) : (
                <img src={logoImage} alt="نبض كير - Nabd Care" />
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;